import React from 'react'

import { CssVars, SemanticColorToken } from '../../themes'
import { Type } from '../Type'
import { useUniqueId } from '../useUniqueId'

export type Props = {
  children: (
    errorMessageId: string,
    errorMessageElem: React.ReactNode,
    errorMessageString?: string
  ) => React.ReactNode
  errorMessage?: string
}

/**
 * A helper component that manages the logic around when and how to render an error message.
 */
export function ErrorMessageManager(props: Props) {
  const { children, errorMessage } = props
  const errorMessageId = useUniqueId()

  if (!errorMessage) {
    return <>{children('', null)}</>
  }

  const errorMessageElem = (
    <div css={{ marginTop: CssVars.size.gutterWidthXs }} id={errorMessageId}>
      <Type.Text color={SemanticColorToken.Error} size="S">
        {errorMessage}
      </Type.Text>
    </div>
  )

  return <>{children(errorMessageId, errorMessageElem, errorMessage)}</>
}
